class BlogFilter {
  constructor() {
    this.categoryButtons = document.querySelectorAll('.blog-categories__button');
    this.articles = document.querySelectorAll('.blog-articles__article:not(.blog-articles__article-fullwidth)');
    this.featuredArticles = document.querySelectorAll('.blog-articles__article-fullwidth');
    this.articleGrids = document.querySelectorAll('.blog-articles__grid');
    this.pagination = document.querySelector('.pagination');
    this.articlesPerPage = 9;
    this.currentFilter = 'all';
    this.blogUrl = window.location.pathname;
    
    this.init();
  }

  init() {
    this.categoryButtons.forEach(button => {
      button.addEventListener('click', () => this.filterArticles(button));
    });
  }

  filterArticles(selectedButton) {
    // Update active buttons
    this.categoryButtons.forEach(button => {
      button.classList.remove('active');
    });
    selectedButton.classList.add('active');

    const selectedTag = selectedButton.getAttribute('data-tag');
    this.currentFilter = selectedTag;

    // Check if second slide should be visible
    if (this.featuredArticles.length > 1) {
      const featuredArticle2 = this.featuredArticles[1]; // Second slide
      const featuredArticle2Tags = featuredArticle2.getAttribute('data-tags').split(' ');
      if (selectedTag === 'all' || featuredArticle2Tags.includes(selectedTag)) {
        featuredArticle2.style.display = 'block';
      } else {
        featuredArticle2.style.display = 'none';
      }
    }

    if (selectedTag === 'all') {
      // Restore original view
      this.restoreGrids();
    } else {
      // Filter all blog articles
      this.filterAllBlogArticles(selectedTag);
    }

    // Scroll to articles section
    document.querySelector('.blog-articles').scrollIntoView({ behavior: 'smooth' });
  }

  async filterAllBlogArticles(selectedTag) {
    
    try {
      // Get all blog articles
      const response = await fetch(`${this.blogUrl}?view=ajax`);
      const html = await response.text();
      
      // Parse HTML and find articles
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find all articles with selected tag
      const allArticles = doc.querySelectorAll('.blog-articles__article');
      const filteredArticles = Array.from(allArticles).filter(article => {
        const articleTags = article.getAttribute('data-tags').split(' ');
        return articleTags.includes(selectedTag);
      });


      // Hide all grids
      this.articleGrids.forEach(grid => {
        grid.style.display = 'none';
      });

      // Create new combined grid with filtered articles
      const firstGrid = this.articleGrids[0];
      if (firstGrid) {
        firstGrid.style.display = 'grid';
        firstGrid.innerHTML = '';

        // Add all filtered articles to first grid
        filteredArticles.forEach(article => {
          const articleClone = article.cloneNode(true);
          firstGrid.appendChild(articleClone);
        });
      }

      // Hide pagination during filtering
      if (this.pagination) {
        this.pagination.style.display = 'none';
      }
      
    } catch (error) {
      console.error('Error filtering articles:', error);
      // Fallback to filtering only visible articles
      this.filterVisibleArticles(selectedTag);
    }
  }

  filterVisibleArticles(selectedTag) {
    
    // Find all visible articles with selected tag
    const filteredArticles = Array.from(this.articles).filter(article => {
      const articleTags = article.getAttribute('data-tags').split(' ');
      return articleTags.includes(selectedTag);
    });



    // Hide all grids
    this.articleGrids.forEach(grid => {
      grid.style.display = 'none';
    });

    // Create new combined grid with filtered articles
    const firstGrid = this.articleGrids[0];
    if (firstGrid) {
      firstGrid.style.display = 'grid';
      firstGrid.innerHTML = '';

      // Add all filtered articles to first grid
      filteredArticles.forEach(article => {
        const articleClone = article.cloneNode(true);
        firstGrid.appendChild(articleClone);
      });
    }

    // Hide pagination during filtering
    if (this.pagination) {
      this.pagination.style.display = 'none';
    }
  }

  restoreGrids() {
    
    // Restore original grids
    this.articleGrids.forEach((grid, index) => {
      grid.style.display = 'grid';
    });

    // Restore original content of first grid
    const firstGrid = this.articleGrids[0];
    if (firstGrid) {
      // Restore original articles (2-10)
      firstGrid.innerHTML = '';
      const originalArticles = Array.from(this.articles)
        .filter(article => !article.classList.contains('blog-articles__article-fullwidth'))
        .slice(0, 9);
      originalArticles.forEach(article => {
        const articleClone = article.cloneNode(true);
        firstGrid.appendChild(articleClone);
      });
    }

    // Restore original content of second grid
    const secondGrid = this.articleGrids[1];
    if (secondGrid) {
      // Restore original articles (11-16)
      secondGrid.innerHTML = '';
      const originalArticles = Array.from(this.articles)
        .filter(article => !article.classList.contains('blog-articles__article-fullwidth'))
        .slice(9, 15);
      originalArticles.forEach(article => {
        const articleClone = article.cloneNode(true);
        secondGrid.appendChild(articleClone);
      });
    }

    // Restore pagination
    if (this.pagination) {
      this.pagination.style.display = 'flex';
    }
  }
}

// Initialize filtering after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new BlogFilter();
   const urlParams = new URLSearchParams(window.location.search);
  const tagFromUrl = urlParams.get("tag");

  // url tag
  if (tagFromUrl) {
    const matchingButton = document.querySelector(`.blog-categories__button[data-tag="${tagFromUrl}"]`);
    if (matchingButton) {
      matchingButton.click(); 
    }
  }
}); 